import ApiBuilder from '../helpers/ApiBuilder';

const getUserContracts = () => {
  return ApiBuilder.ADMIN_API.get('/api/softrig/manageapplication/contracts');
};

const getAgreementsForContract = (contractId) => {
  return ApiBuilder.ADMIN_API.get(`/api/softrig/manageapplication/agreements?contractId=${contractId}`);
};

const acceptAgreement = (agreementId, contractId) => {
  const body = {
    ContractId: contractId,
    AgreementId: agreementId
  }
  return ApiBuilder.ADMIN_API.post('/api/softrig/manageapplication/accept-agreement', body);
};


const createContract = (email, displayName, companyName) => {
  const body = {
    Email: email,
    DisplayName: displayName,
    CompanyName: companyName,
    ContractType: 'Partner',
  }
  return ApiBuilder.API.post('/api/init/confirmation', body);
};

export default {
  getUserContracts,
  getAgreementsForContract,
  acceptAgreement,
  createContract
};